import { SVGProps } from 'react';
import { ReactComponent } from 'icons/empty-circle.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const EmptyCircle = (props: Props) => (
  // @ts-ignore
  <ReactComponent {...props} alt="empty circle" />
);
